// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3gRvp","options":"AnswerScale_options__3gGYW","selected":"AnswerScale_selected__3Sutu"};